// pfs-icon-button.ts — generischer Icon-Button + optionales Popover-Trigger-Wiring
// (PFS-603, Epic PFS-591).
//
// Loest die ueber mednet-main/u. a. duplizierten HEADER_BUTTON_STYLES +
// inline-Popover-Toggle-Verdrahtungen ab. Nutzt das geteilte ICON_BUTTON_CSS
// (Hover/Rest aus --pfs-icon-btn-* / --pfs-color-*) → voll brandbar.
//
// Attribute (alle data-*):
//   data-label       aria-label (Pflicht fuer reine Icon-Buttons = a11y)
//   data-popover-id  optional: Click dispatched `pfs:popover-toggle` auf document.body
//                    mit detail.{targetId, rect} → ein <pfs-popover> gleicher id oeffnet
//   data-href        optional: Click navigiert per Full-Page-Load dorthin (z. B. Logout).
//                    Der Layout-Provider kennt die konkrete URL, nicht das WC.
//
// Slot (default): das Icon-SVG.
// Event: feuert `pfs:icon-button-click` (bubbles) — fuer Consumer ohne Popover.
//
// Beispiel:
//   <pfs-icon-button data-label="Benachrichtigungen" data-popover-id="bell-pop">
//     <svg ...></svg>
//   </pfs-icon-button>
import { defineComponent } from "../../composition/define-component.js";
import { withShadow } from "../../composition/with-shadow.js";
import { ICON_BUTTON_CSS } from "../../styles/icon-button.js";

const STYLES = `
:host { display: inline-flex; }
${ICON_BUTTON_CSS}
button > ::slotted(svg) { width: var(--pfs-icon-btn-icon-size, 1.25rem); height: var(--pfs-icon-btn-icon-size, 1.25rem); }
`;

defineComponent({
  tagName: "pfs-icon-button",
  mixins: [withShadow()],
  render(host, ctx) {
    if (!ctx.shadowRoot) return;
    const root = ctx.shadowRoot;
    const style = document.createElement("style");
    style.textContent = STYLES;
    root.appendChild(style);

    const btn = document.createElement("button");
    btn.type = "button";
    const label = host.dataset.label;
    if (label) btn.setAttribute("aria-label", label);
    btn.appendChild(document.createElement("slot"));
    root.appendChild(btn);

    const onClick = () => {
      const pop = host.dataset.popoverId;
      if (pop) {
        const rect = btn.getBoundingClientRect();
        document.body.dispatchEvent(
          new CustomEvent("pfs:popover-toggle", {
            bubbles: false,
            detail: { targetId: pop, rect },
          }),
        );
      }
      host.dispatchEvent(new CustomEvent("pfs:icon-button-click", { bubbles: true }));
      // Navigations-Naht: Full-Page-Load (Logout etc.) — nach dem Event, damit
      // Consumer noch reagieren koennen, bevor die Seite wechselt.
      const href = host.dataset.href;
      if (href && typeof window !== "undefined") window.location.assign(href);
    };
    btn.addEventListener("click", onClick);
    ctx.cleanup.push(() => btn.removeEventListener("click", onClick));
  },
});
